/**
 * @file dnneditor.class.js
 * @description Defines the DNNEditor class.
 */

class DNNEditor {
  constructor(debug = false) {
    this.elContentPanes = null;
    this.init();
    this.debug();
  }

  init() {
    this.initContentPanes();

    if (this.elContentPanes !== null) {
      this.initContentPaneTitles();
    }
  }
  
  /**
   * @description Selects all of the content panes when the class
   * dnnEditState is applied to the body.
   */
  initContentPanes() {
    if (document.body.classList.contains('dnnEditState')) {
      this.elContentPanes = document.querySelectorAll('.dnnModuleManager');
    }
  }

  /**
   * @description Displays the id of the content pane above each module.
   */
  initContentPaneTitles() {
    this.elContentPanes.forEach( (elContentPane) => {
      let elModules = elContentPane.querySelectorAll('.DNNModuleContent');
      let contentPaneTitle = elContentPane.getAttribute('data-name');

      elModules.forEach( (elModule) => {
        let elContentPaneTitle = document.createElement('h4');
        elContentPaneTitle.innerHTML = contentPaneTitle;
        elContentPaneTitle.classList.add('content-pane-title');
        elModule.prepend(elContentPaneTitle);
      });
    });
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c DNNEditor', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}